export default __webpack_public_path__ + "static/media/logo-idhouse.7e36cb77.svg";